import { render, staticRenderFns } from "./ReviewCriteriaListItem.vue?vue&type=template&id=b4764d90&scoped=true&"
import script from "./ReviewCriteriaListItem.vue?vue&type=script&lang=js&"
export * from "./ReviewCriteriaListItem.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCriteriaListItem.vue?vue&type=style&index=0&id=b4764d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4764d90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VHover,VIcon,VTextarea})
